import pluralize from 'pluralize'

const createIndexIdsReducer =
  (entityName) =>
  (state: any[] = [], action) => {
    const pluralEntityName = pluralize(entityName, 2)

    switch (action.type) {
      case `FETCH_${pluralEntityName.toUpperCase()}_SUCCESS`:
        return [...action.entities.map((entity) => entity.id)]
      default:
        return state
    }
  }

export default createIndexIdsReducer
